const SUPPORTED_BURN_CENTER_DEVICES = ['microbit', 'domiCar'];

const getAvailableBurnCenterDevices = extensionManager => (
    SUPPORTED_BURN_CENTER_DEVICES.filter(device => extensionManager.isExtensionLoaded(device))
);

const resolveBurnCenterEntry = availableDevices => {
    if (availableDevices.length === 1) {
        return {
            device: availableDevices[0],
            selectorOpen: false
        };
    }
    return {
        device: null,
        selectorOpen: true
    };
};

export {
    getAvailableBurnCenterDevices,
    resolveBurnCenterEntry,
    SUPPORTED_BURN_CENTER_DEVICES
};
